import AuthContext from "@/store/contexts/AuthContext";
import { useContext, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";

const getCurrentState = (saveKey: string) => {
  const savedState = localStorage.getItem("state-manager") || "{}";
  const state = JSON.parse(savedState);

  const currentState = state[saveKey] || {
    current_page: "",
    sidebar_open: true,
    scroll_position: 0,
  };
  return currentState;
};

const NavigatePage = () => {
  const { pages } = useContext(AuthContext);
  const location = useLocation();
  const saveKey = useRef(
    localStorage.getItem("state-manager-key") || "default"
  );

  const state = getCurrentState(saveKey.current);

  if (location.pathname === "/" && pages.length !== 0) {
    return <Navigate replace to={state.current_page || pages[0].id} />;
  }

  if (location.pathname === "/public" && pages.length !== 0) {
    return (
      <Navigate
        replace
        to={`/public/${state.current_page || pages[0].id}`.replace(
          "/public//",
          "/"
        )}
      />
    );
  }

  return null;
};

export default NavigatePage;
